import React from 'react';
import FsPlayer from '../../shared/components/FsPlayer';
import VideoThumb from './VideoPlaylistItem';
import { StyleSheet, css } from 'aphrodite/no-important';
import { styles } from './styles/VideoPlaylistStyles';


class VideoPlaylist extends React.Component {
    constructor(props){
        super(props);

        this.title = this.props.title;
        this.hideTitle = this.props.hideTitle && ! this.title || false;
        let videos = this.props.videos || [];
        this.state = { 
            activeIndex: this.props.upNext, 
            skipFirst: this.props.skipFirst || false,  //we want to skip the first item when this is used by VideoPlayer react Component
            videos: videos
        };

        //passing the callback which returns the post the user clicks on 
        this.updateCurrentPost = this.props.onClick;

        //callback to the //VideoPlayer.js to set active state 
        this.setActiveState = this.props.setActiveState;

        this.updateDetails = (e) => {
            return (this.props.showDetails && this.props.showDetails(e));
        };

    }

    componentDidMount() {
        this.cont.addEventListener('scroll', this.updateDetails);
    }
    componentWillUnmount() {
        this.cont.removeEventListener('scroll', this.updateDetails);
    }

    render() {
        const videos = this.state.videos;
        let activeItem = this.props.upNext;

        return (
            <div ref={elem => this.cont = elem} className={css(styles.playlistCont) + " playlist-container"}> 
                {!this.hideTitle && <h3 className={css(styles.compTitle)}> {this.title} </h3> }
                <div className={"vm-more-videos"}>
                    {   videos ?
                            videos.map((item, index) => {
                                if(this.state.skipFirst) {
                                    if( index != 0 ) {
                                        return <VideoThumb post={item} index={index} activeItem={activeItem} setActiveState={this.setActiveState} onClick={this.updateCurrentPost}></VideoThumb>
                                    }
                                } else {
                                    return <VideoThumb post={item} index={index} activeItem={activeItem} setActiveState={this.setActiveState} onClick={this.updateCurrentPost}></VideoThumb>
                                }
                            })
                        : 
                        <div></div>
                    }
                    {  
                        this.props.enableShowMore && <a href="javascript:;" className={css(styles.showMore)}>  </a>
                    }
                </div>
            </div>
        )
    }
}

export default VideoPlaylist;